import { Button, Grid, useDisclosure } from '@chakra-ui/react'
import { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { OfferAddon, OfferVehicle } from 'BrokerTsLib/src/dtos/Offer'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import CarkulkaExtraOffersProvider, { carkulkaExtraOffersContext } from '../../context/CarkulkaExtraOffersProvider'
import CarkulkaOffersProvider, { carkulkaOffersContext } from '../../context/CarkulkaOffersProvider'
import { useApp } from "../../hooks/useApp"
import { useUpdateInsuranceStartDate, useUpdateLastWizardStep } from '../../hooks/useWizard'
import { useSaveSelectedAddonInsurance } from '../../hooks/useWizardAddon'
import { Check } from '../../icons'
import { insuranceParamsContext } from '../../layouts/Wizard'
import { NewInsuranceVariantWrapper } from '../carkulka/NewInsuranceVariantWrapper'
import { ExtraInsuranceModal } from '../ExtraInsuranceModal'
import { FormButtons } from '../FormButtons'
import { OffersBottomToolbar } from './OffersBottomToolbar'
import { OffersCarList } from './OffersCarList'
import { OffersToolbar } from './OffersToolbar'

export type VariantGroupingData = {
  pov: RiskVariantInfo[]
  hav: RiskVariantInfo[]
  spol: RiskVariantInfo[]
  glass: RiskVariantInfo[]
}

export type RiskVariantInfo = {
  id: number
  name: string
}

export const OffersCar = () => {
  const { insuranceParams, insuranceParamsId } = useContext(insuranceParamsContext) ?? {}
  const isContract = !!insuranceParams?.generalParams.contractNumber

  if (!insuranceParamsId)
    return null

  return (
    <CarkulkaOffersProvider insuranceParamsId={insuranceParamsId} isContract={isContract}>
      <CarkulkaExtraOffersProvider insuranceParamsId={insuranceParamsId} isContract={isContract}>
        <_OffersCar />
      </CarkulkaExtraOffersProvider>
    </CarkulkaOffersProvider>
  )
}

const _OffersCar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { app } = useApp()
  const onlyAddons = app === 'carkulka-extra'

  const { insuranceParams, insuranceParamsId, refetchInsuranceParams } = useContext(insuranceParamsContext) ?? {}
  const isContract = !!insuranceParams?.generalParams.contractNumber

  const { recalculateOffers: recalculate, offers, showAll, setShowAll, sortBy, setSortBy: changeSortBy, updateOffer, calculatingOffersIds } = useContext(carkulkaOffersContext)
  const { recalculateOffers: recalculateAddonOffers, offers: addonOffers } = useContext(carkulkaExtraOffersContext)
  const { mutateAsync: updateInsuranceStartDate } = useUpdateInsuranceStartDate(insuranceParamsId!)
  const { mutateAsync: updateStep } = useUpdateLastWizardStep()

  const isCalculatingInProgress = (calculatingOffersIds ?? []).length > 0

  const isAddonSelectedAndValid = (addonOffers: OfferAddon[], insuranceParams: InsuranceParamsDto): boolean => {
    const validOffers = addonOffers.filter((o) => o.valid)

    if (validOffers.length == 0) {
      return false;
    }

    for (let i = 0; i < validOffers.length; i++) {
      if (insuranceParams.baseParams.addonVariants?.find(
        (x) => x.riskVariantId == validOffers[i].riskVariantId)?.selected ?? false) {
        return true
      }
    }

    return false
  }

  const { mutateAsync: saveSelectedAddonInsurance } = useSaveSelectedAddonInsurance()
  const navigate = useNavigate()
  const [isGoingToStep3, setIsGoingToStep3] = useState(false)

  const onGoAddonStep3 = () => {
    setIsGoingToStep3(true)
    saveSelectedAddonInsurance(Number(insuranceParamsId))
      .then(() => {
        updateStep({ paramsId: Number(insuranceParamsId), step: 3, stepsStep: 'carkulka-extra' }).then(() => {
          refetchInsuranceParams().then(() => {
            navigate(`/carkulka/extra/wizard/3/${insuranceParamsId}`)
          })
        }
        )
      })
      .catch(data => {
        setIsGoingToStep3(false)
        console.log('an error occurred when cloning insurance params', data)
        alert("Došlo k chybě při ukládání")
      })
  }


  return (
    <Grid gap={8}>
      {!onlyAddons &&
        <OffersToolbar
          offers={offers}
          editable={!isContract && !isCalculatingInProgress}
          showAll={showAll}
          setShowAll={setShowAll}
          onSettingsClick={() => onOpen()}
          onSetStartDate={(date: Date) => {
            return updateInsuranceStartDate(date)
              .then(() => {
                recalculate(offers.map(o => o.offerId), true)
                if (addonOffers && addonOffers.length > 0) {
                  recalculateAddonOffers(addonOffers.map(ao => ao.offerId), true)
                }
                refetchInsuranceParams() // aby se updatnul header
              })
          }}
          sortBy={sortBy}
          changeSortBy={(sortBy) => changeSortBy(sortBy)}
          updateOffer={(offer) => updateOffer(offer as OfferVehicle)}
        />
      }

      <OffersCarList />

      {!isContract && onlyAddons && addonOffers && isAddonSelectedAndValid(addonOffers, insuranceParams as InsuranceParamsDto) &&
        <FormButtons
          rightButtons={
            <Button
              colorScheme="primary"
              isLoading={isGoingToStep3}
              disabled={isGoingToStep3 /* || !isAddonSelectedAndValid(addonOffers, insuranceParams)*/} //disabled nefunguje??
              loadingText="Ukládám..."
              onClick={() => onGoAddonStep3()}
            >
              <Check />
              Sjednat
            </Button>
          }
        />
      }

      <OffersBottomToolbar />

      {!isContract && !onlyAddons && insuranceParamsId &&
        <NewInsuranceVariantWrapper />
      }

      {insuranceParams && !onlyAddons && <ExtraInsuranceModal isOpen={isOpen} onClose={onClose} />}
    </Grid>
  )
}